import $ from 'jquery';
import {addNotification} from "./notifications";
import {blockUi, unblockUi} from "./blockui";

let mobileBreakpoint = 1150;

const Header = () => {

    if (window.innerWidth < mobileBreakpoint) {
        $(".menu-item-has-children").on("click", function (e) {
            if (!$(this).hasClass("active-nav")) {
                e.preventDefault();
                $(this).addClass("active-nav");
            }
        });
    }

    $(window).on('scroll load', function () {
        const totalScroll = $(window).scrollTop();
        const headerHeight = 10;
        if (totalScroll >= headerHeight) {
            $('header').addClass('sticky');
        } else {
            $('header').removeClass('sticky');
        }
    });

    $('.header-hamburger').on('click', () => {
        $('.header_menu').toggleClass('active');
    });
    $('.nav-item > a ').on('click', () => {
        $('.header_menu').toggleClass('active');
    });
    $('.close-menu').on('click', () => {
        $('.header_menu').toggleClass('active');
    });


    $("#search-icon-header").on("click", function (e) {
        console.log("click");
        if (window.innerWidth > 1150) {
            if ($(".search-input").hasClass("is-open")) {
                $(this).parent().submit();
            } else {
                $(".search-input").addClass("is-open");
                $(this).addClass("is-open");
            }
        } else {
            $(this).parent().trigger("submit");
        }
    })

    $(".header-hamburger").on("click", () => {
        $(".mobile-menu").toggleClass("mobile-menu__active");
        $(".header-container").toggleClass("m-menu-open")
    })

    $(".notification-widget__button").on("click",function () {
        $(".notification-widget__button").toggleClass("notification-widget__button--open");
        $(".notifications").toggle();
    })

    $(".notifications__close").on("click",function () {
        $(".notifications").toggle();
        $(".notification-widget__button").toggleClass("notification-widget__button--open");
    })

}

$(document).ready(Header);

const CartWidget = () => {
    $(".cart-widget-container").on("click", "#mini-cart-icon", function () {
        if (window.innerWidth >= 1024) {
            $(".cart-widget").toggle();
        }else{
            window.location.replace("/cart");
        }
    })
    $(".cart-widget-container").on("click", ".toggle-type", function () {
        // getCartWidget();
    })

    function getCartWidget() {
        $.ajax({
            url: tromplo.ajax_url,
            type: 'post',
            data: {
                action: 'cart_widget',
            }
        })
            .done(response => {
                if (response['status'] === 'success') {
                    if (response['html'].length) {
                        $(".cart-widget-container").html(response['html']);
                        if (window.innerWidth >= 1024) {
                            $(".cart-widget").show();
                        }
                        unblockUi($(".cart-widget-container"));
                    }
                } else {
                    addNotification(response['message'], 'error');
                }
            })
            .fail(response => {
                addNotification('Error. Try again later.', 'error');
            });
    }

    $('.cart-widget-container').on('click', ".widget-product-type-change a", function () {
        const $this = $(this);
        let $wrapper = $(".cart-widget");
        if ($wrapper.length) {
            const $spinner = blockUi($wrapper);
            $spinner.css('position', 'fixed');
            $('.cart-widget-container').attr('data-spinner', $spinner.attr('id'));
        }
        $.get($this.data('remove'), (data) => {
            $.get($this.data('add'), (data) => {
                $('[name="update_cart"]').removeAttr('disabled').click();
                //$(".cart-widget-container").on("click",'')
                getCartWidget();
            });
        })
    });


    $(document.body).on('added_to_cart', function (event, fragments, cart_hash, $button) {
        getCartWidget();
    });
}
$(document).ready(CartWidget);


const Notifications  = () =>{

    $(".notification").on("pointerenter",function(){
        if($(this).find(".notification__new").length > 0){
        $.ajax({
            url: tromplo.ajax_url,
            type: 'post',
            data: {
                action: 'note_mark_read',
                note_id: $(this).find(".set-read").attr("data-id")
            }
        })
        .done(response => {
            $(this).find(".notification__new").remove();
            let count = parseInt($(".notification-widget__button").attr("data-cartcount"));
            if(count > 0){
                count--;
                $(".notification-widget__button").attr("data-cartcount",count);
            }
        })
        .fail(response => {
            addNotification('Error. Try again later.', 'error');
        });
    }
    });

    $(".set-read").on("click",function(){
        $.ajax({
            url: tromplo.ajax_url,
            type: 'post',
            data: {
                action: 'note_mark_read',
                note_id: $(this).attr("data-id")
            }
        })
        .done(response => {
            $(this).parent().parent().parent().find(".notification__new").remove();
            let count = parseInt($(".notification-widget__button").attr("data-cartcount"));
            if(count > 0){
                count--;
                $(".notification-widget__button").attr("data-cartcount",count);
            }
        })
        .fail(response => {
            addNotification('Error. Try again later.', 'error');
        });
    });

    $(".delete-notify").on("click",function(){
        $.ajax({
            url: tromplo.ajax_url,
            type: 'post',
            data: {
                action: 'note_delete',
                note_id: $(this).attr("data-id")
            }
        })
        .done(response => {
            $(this).parent().parent().parent().parent().remove();
        })
        .fail(response => {
            addNotification('Error. Try again later.', 'error');
        });
    });

    $(".disable-notify").on("click",function(){
        $.ajax({
            url: tromplo.ajax_url,
            type: 'post',
            data: {
                action: 'disable_note',
                event_type: $(this).attr("data-event")
            }
        })
        .done(response => {
            $(this).parent().parent().parent().parent().remove();
        })
        .fail(response => {
            addNotification('Error. Try again later.', 'error');
        });
    });

    $(".notifications-set-read-all").on("click", function(){
        $.ajax({
            url: tromplo.ajax_url,
            type: 'post',
            data: {
                action: 'note_mark_read_all',
                user_id: $(this).attr("data-user"),
            }
        })
        .done(response => {
            $(".notification").find(".notification__new").remove();
        })
        .fail(response => {
            addNotification('Error. Try again later.', 'error');
        });
    });

    $(".open-settings").on("click",function(){
 
        $(this).find(".settings").toggleClass("flex");
        if(window.innerWidth > 1024){
            setInViewport($(this).find(".settings").get(0),$(this).get(0));
        }
    })
    

    function setInViewport(element,parentElement) {
        let nofiticationContainer = document.querySelector(".notifications");
        if(!(element.clientHeight + parentElement.offsetTop <= nofiticationContainer.offsetHeight)){
            let top = element.clientHeight + parentElement.offsetTop - nofiticationContainer.offsetHeight;
            element.style.top = -1 * (top+16)+"px";
        }
    }
} 

$(document).ready(Notifications);


